module.exports = __webpack_public_path__ + "static/media/testimonial3.b6d30a14.jpg";